import config from "@/config"
import http from "@/utils/request"
import { DemandStatus } from "@/utils/constants"
export default {
  demand: {
    manage: {
      url: `${config.API_URL}/demand/manage`,
      demandOperateUrl: `${config.API_URL}/demandOperate/manage`,
      name: "获取待审核需求列表",
      get: async function (params) {
        return await http.get(`${this.url}/getUnApplyDemandList`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/checkDemand`, data) //对需求单进行审核
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      getOperates: async function (params) {
        return await http.get(`${config.API_URL}/demandOperate/manage/getOperationsById`, params)
      }
    }
  },
  biddingDemand: {
    url: `${config.API_URL}/demand/manage`,
    name: "获取正在招标的需求列表",
    get: async function (params) {
      return await http.get(`${this.url}/getBiddingDemandList`, params)
    },
    del: async function (data) {
      return await http.post(`${this.url}/downDemand`, data) //下架招标中的需求
    }
    // submit: async function (data) {
    //   return await http.post(`${this.url}/checkDemand`, data) //对需求单进行审核
    // }
  },
  //getList
  list: {
    url: `${config.API_URL}/demand/manage`,
    name: "获取需求列表",
    getDownList: {
      get: async function (data) {
        return await http.post(`${config.API_URL}/demand/manage/getList`, { ...data, status: DemandStatus.DOWN })
      }
    },
    getRejectedList: {
      get: async function (data) {
        return await http.post(`${config.API_URL}/demand/manage/getList`, { ...data, status: DemandStatus.REJECTED })
      }
    }
  }
}
